module.exports = __webpack_public_path__ + "0c0bef998741abf80120ed76679b61dc.jpg";